import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Grid,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { investorApi } from "../api/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SubscriptionPlans from "../components/VendorSubscription/SubscriptionPlans";
import SubscriptionDetails from "../components/VendorSubscription/VendorSubscriptionDetails";
const VendorSubscriptionScreen = () => {
  const userId = useSelector((state) => state.user.userId);
  const isSubscribed = useSelector((state) => state.user.isSubscribed);
 
  const navigate = useNavigate();
  // if (!isSubscribed) {
  //   return (
  //     <Container maxWidth="md" sx={{ pt: 6 }}>
  //       <Typography align="center">
  //         <CircularProgress />
  //       </Typography>
  //     </Container>
  //   );
  // }
  // :white_check_mark: Show details if user is already subscribed
  // console.log(isSubscribed);
  // debugger
  if (isSubscribed) {
    return <SubscriptionDetails />;
  }
  else {
    return <SubscriptionPlans/>
  }
};
export default VendorSubscriptionScreen;